import { render, staticRenderFns } from "./hl7-messages.vue?vue&type=template&id=4218168b"
import script from "./hl7-messages.vue?vue&type=script&lang=js"
export * from "./hl7-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports